import { Form, Input, InputNumber, Modal, Select, Space, Switch } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Button } from '~/app/components/common/Button';
import { TaskSubtasksField } from '~/app/components/maintenance/TaskSubtasksField/TaskSubtasksField';
import type { TaskResponseDto } from '@evimo/client/models';
import { useTasksTab } from './hooks/useTasksTab';
import { EvimoTable } from '~/app/components/common/EvimoTable/EvimoTable';

export function TasksTab() {
  const { t } = useTranslation('maintenance');
  const {
    tasks,
    tasksLoading,
    columns,
    expandable,
    modalOpen,
    editingTask,
    form,
    closeModal,
    openCreate,
    handleSubmit,
    isSaving,
    workTypeOptions,
    partOptions,
  } = useTasksTab();

  return (
    <>
      <Space
        style={{ width: '100%', justifyContent: 'flex-end', marginBottom: 16 }}
      >
        <Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>
          {t('tasks.create')}
        </Button>
      </Space>
      <EvimoTable<TaskResponseDto>
        className="pmp-tasks-with-subtasks"
        rowKey="id"
        loading={tasksLoading}
        columns={columns}
        dataSource={tasks}
        expandable={expandable}
        pagination={{ pageSize: 10, showSizeChanger: true }}
        size="middle"
      />

      <Modal
        open={modalOpen}
        title={editingTask ? t('tasks.editTitle') : t('tasks.createTitle')}
        onCancel={closeModal}
        onOk={() => void handleSubmit()}
        confirmLoading={isSaving}
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label={t('tasks.name')}
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="workTypeId"
            label={t('tasks.workType')}
            rules={[{ required: true }]}
          >
            <Select
              options={workTypeOptions.map((wt) => ({
                label: t(`workType.${wt.code}`),
                value: wt.value,
              }))}
              placeholder={t('tasks.selectWorkType')}
            />
          </Form.Item>
          <Form.Item
            name="mandatory"
            label={t('tasks.mandatory')}
            valuePropName="checked"
            initialValue={true}
          >
            <Switch />
          </Form.Item>
          <Form.Item
            name="requiresShutdown"
            label={t('tasks.requiresShutdown')}
            valuePropName="checked"
            initialValue={false}
          >
            <Switch />
          </Form.Item>
          <Form.Item
            name="estimatedDurationMinutes"
            label={t('tasks.duration')}
          >
            <InputNumber min={1} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="partIds" label={t('tasks.parts')}>
            <Select
              mode="multiple"
              options={partOptions}
              placeholder={t('tasks.selectParts')}
            />
          </Form.Item>
          <TaskSubtasksField />
        </Form>
      </Modal>
    </>
  );
}
